import DealSavingsTypes from "@irati/deals/types/enums/DealSavingsType"
import {Deal} from "@irati/types"
import id from "@irati/utils/id"
import React from "react"
import Amount from "./Amount"
import Free from "./Free"
import SpecialRates from "./SpecialRates"

export type SavingProps = {
  deal: Deal
  size?: "small" | "extra-small"
  addSavingsTypeEmoji?: boolean
  smallSavingsHeader?: boolean
  allowEarnPointsModal?: boolean
  isMobile?: boolean
}

export const SavingBlock = ({addSavingsTypeEmoji, smallSavingsHeader, ...props}: SavingProps) => {
  const deal = props.deal as Required<Deal>
  const {userSavings} = deal.savings
  const idNamespace = id("saving", {id: deal.uuid})

  switch (userSavings?.type) {
    case DealSavingsTypes.SPECIAL_RATES:
      return <SpecialRates {...props} id={id("special-rates", idNamespace)} small={smallSavingsHeader} />

    case DealSavingsTypes.FREE:
      return <Free {...props} id={id("free", idNamespace)} emoji={addSavingsTypeEmoji ? "🎂" : ""} small={smallSavingsHeader} />

    default:
      return <Amount {...props} deal={deal} small={smallSavingsHeader} />
  }
}
